module.exports = __webpack_public_path__ + "static/media/home_page_wittledefender_background@2x.3b58fc98.png";